import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/cardDetailList";

const getLuckyDrawCardDetailList = async (productId) => {
  const { data: { data = {} } } = await axios.get(endpoint_url, {
    params: { product_id: productId }
  });
  const rows = Array.isArray(data.data) ? data.data : [];
  return rows;
};

export default getLuckyDrawCardDetailList;